/**
 * Get the appropriate backend URL based on environment
 */
export function getBackendUrl(): string {
  // Check if we're in development (localhost)
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:8002';
  }
  
  // Production - use deployed backend
  return 'https://prune-forensics.onrender.com';
} 